export default __webpack_public_path__ + "static/media/activation-sent.284c3425.png";